// extracted by mini-css-extract-plugin
module.exports = {"basicButton":"homepage_basicButton__8P8W6","menuIcon":"homepage_menuIcon__diWyf","fadein":"homepage_fadein__111sN","loading":"homepage_loading__x86zO"};